import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort',
  standalone: true,
})
export class SortPipe implements PipeTransform {
  transform<T>(value: T[], key?: keyof T): T[] {
    if (!Array.isArray(value)) return value;
    const arr = [...value];
    if (!key) return arr.sort();
    return arr.sort((a, b) => {
      const av = a[key];
      const bv = b[key];
      return ('' + av).localeCompare('' + bv);
    });
  }
}
